import React, { useEffect, useState } from 'react';
import './CreditDashboard.css';

import MarketRiskUtilisation from "../components/market-risk/MarketRiskUtilisation";
import { PnLVarChart } from "../components/pnl/PnLCharts";
import DateBox from "devextreme-react/date-box";
import MarketRiskStressTests from "../components/market-risk/MarketRiskStressTests";
import MarketRiskGauge from "../components/market-risk/MarketRiskGauge";
import MarketRiskTree from "../components/market-risk/MarketRiskTree";
import VARBacktestTable from "../components/var/VARBacktestTable";
import { baseUrl } from "../hooks/useFetch";
import useCobDate from "../hooks/useCobDate";

interface DashboardData {
  risk_tree: any[];
  gauge: number | null;
  util_years: Record<string, any>;
}

const MarketRiskDashboard: React.FC = () => {

  const [cobDate, setCobDate, cobLoading] = useCobDate("/marketrisk_stress_tests_latest_cob");
  const [, , , latestCobDate] = useCobDate("/market_risk/sp_matrix_latest_cob");
 const [treeDataRisk, setTreeDataRisk] = useState<any[]>([]);
 const [utilYears, setUtilYears] = useState<Record<string, any>>({});
 const [gaugeReading, setGaugeReading] = useState<number | null>(null);

   useEffect(() => {
      if (!cobDate) return;
     const formattedSelectedDate = cobDate.toISOString().split("T")[0];
    const url = `${baseUrl}/marketrisk_dashboard?cob_date=${formattedSelectedDate}`;
    //console.log(url);

    fetch(url)
      .then((res) => res.json())
      .then((data: DashboardData) => {
        setTreeDataRisk(data['risk_tree']);
        setGaugeReading(data['gauge']);
        setUtilYears(data['util_years']);
      })
      .catch((err: unknown) => console.error('Failed to load tree data', err));
  }, [cobDate]);


  return (
  <div
    style={{
      overflowY: "auto",
      boxSizing: "border-box"
    }}
  >
    <div
      style={{
        width: "100%",
        display: "grid",
        gridTemplateColumns: "1fr",
        rowGap: 8,
        boxSizing: "border-box"
      }}
    >
         <div
      style={{
        gridColumn: 1,
        gridRow: 1,
        background: "transparent",
        //borderRadius: 12,
        // padding: 1,
        display: "flex",
        alignItems: "center",
        // gap: 1
      }}
    >

  <DateBox
    value={cobDate}
    type="date"
    displayFormat="dd/MM/yyyy"
    onValueChanged={(e: any) => setCobDate(e.value)}
    width={220}
    max={latestCobDate ?? undefined}
  />

    </div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "10fr 1fr",
          //columnGap: 8,
          minWidth: 0,
          minHeight: 0
        }}
      >
        <div
          style={{
            position: "relative",
            //background: "transparent",
            minWidth: 0,
            minHeight: 0,
            overflow: "hidden"
          }}
        >
           <MarketRiskTree treeDataRisk={treeDataRisk}></MarketRiskTree>
        </div>

        <div
          style={{
           display: "flex",
  justifyContent: "center",
  alignItems: "flex-start",
  width: "100%",

          }}
        >
          <MarketRiskGauge gaugeReading={gaugeReading} util_years={utilYears}/>
        </div>
      </div>

         <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr ",
          columnGap: 8,
          minWidth: 0,
          minHeight: 0
        }}
      >
        <div
          style={{
            position: "relative",
            background: "transparent",
            minWidth: 0,
            minHeight: 0,
            overflow: "hidden",
              marginLeft: 25,
          }}
        >
            <h3  style={{ marginLeft: 12 }}>Stress Tests</h3>
          <MarketRiskStressTests  cobDate={cobDate}/>
        </div>

        <div
          style={{
            position: "relative",
            background: "transparent",
            minWidth: 0,
            minHeight: 0,
            overflow: "hidden"
          }}
        >
    {/*<h3  style={{ marginLeft: 12 }}>Placeholder</h3>*/}
           <PnLVarChart cob_date={ cobDate} element_type={'Market Maker Total'} pnl_type={'standalone_var'} page="dashboard"  hide_legend_button={true} height={350}/>
        </div>
         </div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "2fr 3fr",
          // columnGap: 8,
          minWidth: 0,
          minHeight: 0
        }}
      >
        <div
          style={{
            position: "relative",
            background: "transparent",
            minWidth: 0,
            minHeight: 0,
            overflow: "hidden",
              marginLeft: 15,
          }}
        >
            <h3  style={{ marginLeft: 25 }}>VaR Backtesting</h3>
          <VARBacktestTable cobDate={cobDate} book={'Market Maker Total'} page={'dashboard'}  />
        </div>



        <div
          style={{
            position: "relative",
            background: "inherit",
            minWidth: 0,
            minHeight: 0,
            display: "flex",
            alignItems: "stretch",
            overflow: "hidden"
          }}
        >
        </div>
      </div>
    </div>
  </div>
);

};

export default MarketRiskDashboard;
